import { Coins } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useCart } from "@/context/CartContext";
import { useCustomer } from "@/context/CustomerContext";
import { COIN_VALUE, RUPIAH_PER_COIN, rupiah } from "@/lib/api";

export const coinMath = (total, balance, useCoins) => {
  const usable = Math.min(balance, Math.floor(total / COIN_VALUE));
  const used = useCoins ? usable : 0;
  const pay = total - used * COIN_VALUE;
  return { usable, used, pay, earn: Math.floor(pay / RUPIAH_PER_COIN) };
};

export const CoinBox = () => {
  const { total, useCoins, setUseCoins } = useCart();
  const { customer } = useCustomer();
  if (!customer) return null;
  const { usable, used, earn } = coinMath(total, customer.coins, useCoins);

  return (
    <div className="py-3 border-t border-sage-200 space-y-2" data-testid="cart-coin-box">
      <div className="flex items-center justify-between gap-3">
        <span className="flex items-center gap-2 text-sm">
          <Coins className="w-4 h-4 text-amber-600" />
          <span>Pakai Coin <span className="text-muted2">(saldo {customer.coins})</span></span>
        </span>
        <Switch checked={useCoins && usable > 0} disabled={usable === 0} onCheckedChange={setUseCoins} data-testid="cart-use-coins-switch" />
      </div>
      {used > 0 && (
        <div className="flex justify-between text-sm text-forest font-medium" data-testid="cart-coin-discount">
          <span>Potongan {used} Coin</span><span>-{rupiah(used * COIN_VALUE)}</span>
        </div>
      )}
      {earn > 0 && <p className="text-xs text-muted2" data-testid="cart-coin-earn">Kamu dapat +{earn} Coin setelah pembayaran dikonfirmasi.</p>}
    </div>
  );
};
